import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import Footer from "components/Footer";

const { Content } = Layout;

const Component = ({}) => {
  return (
    <Layout className="sp-auth-layout">
      <Content>
        <Outlet />
      </Content>
      <Footer />
    </Layout>
  );
};

export default Component;
